import React from "react";

const Body = (props) => {
  return <div className="body-container">{props.children}</div>;
};

export default Body;
